import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';

const PasswordResetSuccess: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className='success-container'>
      <div className='success-header'>
        <div className='success-header-content'>
          <div className='success-logo'>
            <button onClick={() => navigate('/')}>
              <img
                src="/favicon.png" 
                alt="App Logo" 
                style={{ maxHeight: '40px', width: 'auto' }}
              />
            </button>
          </div>
        </div>
      </div>
      
      <div className='success-content'>
        <div className='success-card'>
          <div className='success-icon'>
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="32" cy="32" r="32" fill="var(--accent-color)"/>
              <path d="M20 32L28 40L44 24" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          
          <h1 className='titles large color black'>Password Reset Successfully!</h1>
          
          <p className='paragraphs medium color charcoal'>
            Your password has been updated. You can now sign in with your new password.
          </p>
          
          <div className='success-actions'>
            <button 
              className='btn primary'
              onClick={() => navigate('/')}
            >
              Return to Home
            </button>
          </div>
          
          <div className='help-text'>
            <p className='paragraphs small color charcoal'>
              If you didn't request this password reset, please contact support immediately.
            </p>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default PasswordResetSuccess; 